import type { QueryParamsDto } from "@mimber/schema"

/**
 * Query keys for payouts
 * Aligns with backend PayoutsController methods
 */
export const payoutsKeys = {
  getSchedule: () => ["payouts", "getSchedule"] as const,
  findAll: (params?: QueryParamsDto) => ["payouts", "findAll", params] as const,
  getTransactions: (payoutId: string) =>
    ["payouts", "getTransactions", payoutId] as const,
} as const
